// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"275":"5524a9d2","798":"bca91676"}[chunkId] + ".css";
};